import { config } from "../../config"
import { User } from "../auth/data-types"
import { Club, TrendingClubList } from "./data-types"

export const getClubById = async (clubId: string, token?: string): Promise<Club> => {
  const authHeaders: {[key: string]: string} = {}
  if (token) {
    authHeaders.token = token
  }

  const res = await fetch(`${config.api.urlV1}/club/${clubId}/`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      ...authHeaders,
    },
  })

  if (res.status !== 200) {
    throw new Error("club not found")
  }

  const club = await res.json()

  return club
}

export const fetchClubMembers = async (clubId: number, offset: number, limit: number, languages: string[], token?: string): Promise<User[]> => {
  const authHeaders: {[key: string]: string} = {}
  if (token) {
    authHeaders.token = token
  }

  const params: any = {
    offset,
    limit,
    club_id: clubId,
  }

  if (languages) {
      params.languages = languages.map(lng => lng.toUpperCase()).join(",")
  }

  const res = await fetch(`${config.api.urlV1}/cafe/users/?${new URLSearchParams(params).toString()}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      ...authHeaders,
    },
  })

  if (res.status !== 200) {
    throw new Error("club not found")
  }

  const users = await res.json()

  return users
}

export const fetchTrendingClubs = async (token?: string): Promise<TrendingClubList> => {
  const authHeaders: {[key: string]: string} = {}
  if (token) {
    authHeaders.token = token
  }

  const res = await fetch(`${config.api.urlV1}/club/rating`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      ...authHeaders,
    },
  })

  if (res.status !== 200) {
    throw new Error("club not found")
  }

  const clubs = await res.json()

  return clubs
}
